import { WidgetTypes } from '@helpers/Enums';
import React, { Component } from 'react';

import Counter from './widgetTypes/Counter';
import Goals from './widgetTypes/Goals';
import List from './widgetTypes/List';
import RangeChart from './widgetTypes/RangeChart';
import BarChart from './widgetTypes/BarChart';
import Table from './widgetTypes/Table';
import GoalsChart from './widgetTypes/GoalsChart';

type PropType = {
  unit: string;
  widget: any;
  id: any;
  deleteWidgetByIndex: Function;
  editWigdets: Function;
  data: any;
  isRegisterModalVisible: boolean;
  recurrency: boolean;
  createWidget: Function;
  duplicateWidget: Function;
  aggregator: any;
  processes: any;
}

type StateType = {
  widget: any;
}

export default class Widgtet extends Component<PropType, StateType> {
  constructor(props: PropType) {
    super(props)
    this.state = {
      widget: []
    }
  }

  duplicateWidget = async () => {
    if (this.props.widget.type === WidgetTypes.RANGE_CHART) {
      const dashboardData = {
        widgetID: this.props.widget.id,
        widgetTitle: this.props.widget.title,
        frequency: (this.props.widget.frequency ? this.props.widget.frequency : this.props.widget.specific),
        data: this.props.widget.data,
        widgetType: this.props.widget.type,
        selectedProcessId: this.props.widget.processId,
        componentKeys: this.props.widget.componentKeys,
        userIds: this.props.widget.userIds,
        minRange: this.props.widget.min,
        maxRange: this.props.widget.max,
        recurrency: this.props.widget.recurrence,
        aggregator: this.props.widget.aggregator
      }
      await this.props.duplicateWidget(dashboardData)
    }
    else if (this.props.widget.type === WidgetTypes.BAR_CHART) {
      const dashboardData = {
        widgetID: this.props.widget.id,
        widgetTitle: this.props.widget.title,
        frequency: (this.props.widget.frequency ? this.props.widget.frequency : this.props.widget.specific),
        data: this.props.widget.data,
        widgetType: this.props.widget.type,
        selectedProcessId: this.props.widget.processId,
        componentKeys: this.props.widget.componentKeys,
        userIds: this.props.widget.userIds,
        minRange: this.props.widget.min,
        maxRange: this.props.widget.max,
        recurrency: this.props.widget.recurrence,
        aggregator: this.props.widget.aggregator
      }
      await this.props.duplicateWidget(dashboardData)
    }
    else if (this.props.widget.type === WidgetTypes.GOALS) {
      const dashboardData = {
        widgetID: this.props.widget.id,
        widgetTitle: this.props.widget.title,
        frequency: (this.props.widget.frequency ? this.props.widget.frequency : this.props.widget.specific),
        data: this.props.widget.data,
        widgetType: this.props.widget.type,
        selectedProcessId: this.props.widget.processId,
        componentKeys: this.props.widget.componentKeys,
        userIds: this.props.widget.auditeds,
        minRange: this.props.widget.min,
        maxRange: this.props.widget.max,
        recurrency: this.props.widget.recurrence,
        aggregator: this.props.widget.aggregator,
        auditedGuest: this.props.widget.auditedGuest,
        auditedOut: this.props.widget.auditedOut,
        auditorGuest: this.props.widget.auditorGuest,
        auditors: this.props.widget.auditors
      }
      await this.props.duplicateWidget(dashboardData)
    }
    else if (this.props.widget.type === WidgetTypes.GOALS_CHART) {
      const dashboardData = {
        widgetID: this.props.widget.id,
        widgetTitle: this.props.widget.title,
        frequency: (this.props.widget.frequency ? this.props.widget.frequency : this.props.widget.specific),
        data: this.props.widget.data,
        widgetType: this.props.widget.type,
        selectedProcessId: this.props.widget.processId,
        componentKeys: this.props.widget.componentKeys,
        userIds: this.props.widget.auditeds,
        minRange: this.props.widget.min,
        maxRange: this.props.widget.max,
        recurrency: this.props.widget.recurrence,
        aggregator: this.props.widget.aggregator,
        auditedGuest: this.props.widget.auditedGuest,
        auditedOut: this.props.widget.auditedOut,
        auditorGuest: this.props.widget.auditorGuest,
        auditors: this.props.widget.auditors
      }
      await this.props.duplicateWidget(dashboardData)
    }
    else {
      const dashboardData = {
        widgetID: this.props.widget.id,
        widgetTitle: this.props.widget.title,
        frequency: (this.props.widget.frequency ? this.props.widget.frequency : this.props.widget.specific),
        data: this.props.widget.data,
        widgetType: this.props.widget.type,
        selectedProcessId: this.props.widget.processId,
        componentKeys: this.props.widget.componentKeys,
        userIds: this.props.widget.userIds,
        recurrency: this.props.widget.recurrence,
        aggregator: this.props.widget.aggregator
      }
      await this.props.duplicateWidget(dashboardData)
    }

    await this.props.createWidget()
  }

  editWidget = () => {
    if (this.props.widget.type === WidgetTypes.RANGE_CHART) {
      const dashboardData = {
        widgetID: this.props.widget.id,
        widgetTitle: this.props.widget.title,
        date: (this.props.widget.frequency ? this.props.widget.frequency : this.props.widget.specific),
        data: this.props.widget.data,
        widgetType: this.props.widget.type,
        selectedProcessId: this.props.widget.processId,
        componentKeys: this.props.widget.componentKeys,
        userIds: this.props.widget.userIds,
        minRange: this.props.widget.min,
        maxRange: this.props.widget.max,
        recurrency: this.props.widget.recurrence,
        aggregator: this.props.widget.aggregator
      }
      this.props.editWigdets(dashboardData)
    }
    else if (this.props.widget.type === WidgetTypes.BAR_CHART) {
      const dashboardData = {
        widgetID: this.props.widget.id,
        widgetTitle: this.props.widget.title,
        date: (this.props.widget.frequency ? this.props.widget.frequency : this.props.widget.specific),
        data: this.props.widget.data,
        widgetType: this.props.widget.type,
        selectedProcessId: this.props.widget.processId,
        componentKeys: this.props.widget.componentKeys,
        userIds: this.props.widget.userIds,
        minRange: this.props.widget.min,
        maxRange: this.props.widget.max,
        recurrency: this.props.widget.recurrence,
        aggregator: this.props.widget.aggregator
      }
      this.props.editWigdets(dashboardData)
    }
    else if (this.props.widget.type === WidgetTypes.GOALS) {
      const dashboardData = {
        widgetID: this.props.widget.id,
        widgetTitle: this.props.widget.title,
        date: (this.props.widget.frequency ? this.props.widget.frequency : this.props.widget.specific),
        data: this.props.widget.data,
        widgetType: this.props.widget.type,
        selectedProcessId: this.props.widget.processId,
        componentKeys: this.props.widget.componentKeys,
        userIds: this.props.widget.auditeds,
        minRange: this.props.widget.min,
        maxRange: this.props.widget.max,
        recurrency: this.props.widget.recurrence,
        aggregator: this.props.widget.aggregator,
        auditedGuest: this.props.widget.auditedGuest,
        auditedOut: this.props.widget.auditedOut,
        auditorGuest: this.props.widget.auditorGuest,
        auditors: this.props.widget.auditors
      }
      this.props.editWigdets(dashboardData)
    }
    else {
      const dashboardData = {
        widgetID: this.props.widget.id,
        widgetTitle: this.props.widget.title,
        date: (this.props.widget.frequency ? this.props.widget.frequency : this.props.widget.specific),
        data: this.props.widget.data,
        widgetType: this.props.widget.type,
        selectedProcessId: this.props.widget.processId,
        componentKeys: this.props.widget.componentKeys,
        userIds: this.props.widget.userIds,
        recurrency: this.props.widget.recurrence,
      }
      this.props.editWigdets(dashboardData)
    }
  }


  widgetSwitch = (widget: any) => {
    //when you filter by component in the api
    let data = this.props.data
    let filteredWidget = this.props.widget
    
    if (this.props.widget.componentKeys && this.props.widget.componentKeys.length > 0) {
      data = data.filter((e: any) => e.components)
      filteredWidget = Object.assign({}, this.props.widget, { data })
    }

    switch (widget) {
      case (WidgetTypes.COUNTER):
        return <Counter
          duplicateWidget={this.duplicateWidget}
          editWidget={this.editWidget}
          deleteWidgetByIndex={this.props.deleteWidgetByIndex}
          unit={this.props.unit}
          widgetID={this.props.widget.id}
          id={this.props.id}
          title={this.props.widget.title}
          data={data}
          widget={filteredWidget} />
      case (WidgetTypes.LIST):
        return <List
          duplicateWidget={this.duplicateWidget}
          editWidget={this.editWidget}
          deleteWidgetByIndex={this.props.deleteWidgetByIndex}
          unit={this.props.unit} widgetID={this.props.widget.id}
          id={this.props.id}
          title={this.props.widget.title}
          data={data}
          widget={filteredWidget} />
      case (WidgetTypes.GROUP):
        return <List
          duplicateWidget={this.duplicateWidget}
          editWidget={this.editWidget}
          deleteWidgetByIndex={this.props.deleteWidgetByIndex}
          unit={this.props.unit}
          widgetID={this.props.widget.id}
          id={this.props.id}
          title={this.props.widget.title}
          data={data}
          widget={filteredWidget} />
      case (WidgetTypes.RANGE_CHART):
        return <RangeChart
          aggregator={this.props.aggregator}
          duplicateWidget={this.duplicateWidget}
          min={this.props.widget.min}
          max={this.props.widget.max}
          editWidget={this.editWidget}
          deleteWidgetByIndex={this.props.deleteWidgetByIndex}
          unit={this.props.unit}
          widgetID={this.props.widget.id}
          id={this.props.id}
          data={data}
          title={this.props.widget.title}
          widget={filteredWidget}
          frequency={this.props.widget.frequency}
          specific={this.props.widget.specific}
        />
      case (WidgetTypes.BAR_CHART):
        return <BarChart
          aggregator={this.props.aggregator}
          duplicateWidget={this.duplicateWidget}
          min={this.props.widget.min}
          max={this.props.widget.max}
          editWidget={this.editWidget}
          deleteWidgetByIndex={this.props.deleteWidgetByIndex}
          unit={this.props.unit}
          widgetID={this.props.widget.id}
          id={this.props.id}
          data={data}
          title={this.props.widget.title}
          widget={filteredWidget}
          frequency={this.props.widget.frequency}
          specific={this.props.widget.specific}
        />
      case (WidgetTypes.GOALS):
        return <Goals
          duplicateWidget={this.duplicateWidget}
          editWidget={this.editWidget}
          deleteWidgetByIndex={this.props.deleteWidgetByIndex}
          unit={this.props.unit}
          widgetID={this.props.widget.id}
          id={this.props.id}
          title={this.props.widget.title}
          data={data}
          widget={filteredWidget} />
      case (WidgetTypes.TABLE):
        return <Table
          processes={this.props.processes}
          duplicateWidget={this.duplicateWidget}
          editWidget={this.editWidget}
          deleteWidgetByIndex={this.props.deleteWidgetByIndex}
          unit={this.props.unit}
          widgetID={this.props.widget.id}
          id={this.props.id}
          title={this.props.widget.title}
          data={data}
          widget={filteredWidget}
          processId={this.props.widget.processId}
          recurrence={this.props.widget.recurrence} />
      case (WidgetTypes.GOALS_CHART):
        return <GoalsChart
          duplicateWidget={this.duplicateWidget}
          editWidget={this.editWidget}
          deleteWidgetByIndex={this.props.deleteWidgetByIndex}
          unit={this.props.unit}
          widgetID={this.props.widget.id}
          id={this.props.id}
          title={this.props.widget.title}
          data={data}
          widget={filteredWidget}
          />
      default:
        return
    }
  }

  render() {
    return (
      <div style={{ padding: 10, width: '100%' }}>
        {this.widgetSwitch(this.props.widget.type)}
      </div>
    )
  }
}
